import s from './DragSelectionOverlay.module.scss';

type DragSelectionOverlayProps = {
  top: number;
  height: number;
  visible: boolean;
};

const DragSelectionOverlay: React.FC<DragSelectionOverlayProps> = ({ top, height, visible }) => {
  if (!visible || height <= 0) return null;

  return <div className={s.drag_selection_overlay} style={{ top, height }} />;
};

export { DragSelectionOverlay };
